import React from "react";
import axios from "axios";
import APIURL from "../../../Main/apiurl";
import { json } from "react-router-dom";

const create_home_service = async (home_service) => {
  try {
    let data = new FormData();
    data.append("image", home_service?.image[0]);
    data.append("title", home_service?.title);
    data.append("description", home_service?.description);
    data.append("status", home_service?.status);

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/create-home-service`,
      data,
      config
    );

    if (response?.data?.status_code == 401) {
      localStorage.clear();
      window.location.href = "/";
      return response?.data;
    } else {
      return response?.data;
    }
  } catch (error) {
    return error;
  }
};

const update_home_service = async (home_service) => {
  try {
    let data = new FormData();
    data.append("id", home_service?.id);
    data.append("image", home_service?.image[0]);
    data.append("title", home_service?.title);
    data.append("description", home_service?.description);
    data.append("status", home_service?.status);

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/update-home-service`,
      data,
      config
    );

    if (response?.data?.status_code == 401) {
      localStorage.clear();
      window.location.href = "/";
      return response?.data;
    } else {
      return response?.data;
    }
  } catch (error) {
    return error;
  }
};

const get_home_service = async (home_service) => {
  try {
    const data = {
      id: home_service?.id,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-home-service`,
      data,
      config
    );

    if (response?.data?.status_code == 401) {
      localStorage.clear();
      window.location.href = "/";
      return response?.data;
    } else {
      return response?.data;
    }
  } catch (error) {
    return error;
  }
};

const get_all_home_services = async (home_service) => {
  try {
    const data = {
      search: home_service?.search,
      sort: home_service?.sort,
      unit: home_service?.unit,
      category: home_service?.category,
      brand: home_service?.brand,
      type: home_service?.type,
      status: home_service?.status,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-all-home-services `,
      data,
      config
    );

    if (response?.data?.status_code == 401) {
      localStorage.clear();
      window.location.href = "/";
      return response?.data;
    } else {
      return response?.data;
    }
  } catch (error) {
    return error;
  }
};

export {
  create_home_service,
  update_home_service,
  get_home_service,
  get_all_home_services,
};
